export class SmartShape extends PIXI.Graphics {

    public shapeWidth: number;
    public shapeHeight: number;
    public shapeFillColor: number;
    public shapeFillAlpha: number;
    public shapeStrokeColor: number;
    public shapeStrokeSize: number;
    public shapeStrokeAlpha: number;
    public shapeCornerRadius: number;

    public draw() {
        this.clear();
        this.lineStyle(this.shapeStrokeSize === 0 ? 1 : this.shapeStrokeSize, this.shapeStrokeColor, this.shapeStrokeSize === 0 ? 0 : this.shapeStrokeAlpha);
        this.beginFill(this.shapeFillColor, this.shapeFillAlpha);

        // Adding 3 to height and width as at some scales shapes can be up to 3 pixels off, leaving hairline gaps
        const adjustedShapeWidth = this.shapeWidth + 3;
        const adjustedShapeHeight = this.shapeHeight + 3;

        if (this.shapeCornerRadius > 0) {
            this.drawRoundedRect(0, 0, adjustedShapeWidth, adjustedShapeHeight, this.shapeCornerRadius);
        } else {
            this.drawRect(0, 0, adjustedShapeWidth, adjustedShapeHeight);
        }

        this.endFill();
    }
}
